import {Directive, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[def-title-select-search]'
})
export class DefTitleSelectSearch {

    @Input() lblId: string;

    constructor() {}

    @HostListener('click') onClick() {
        let idLabel = this.lblId;
        setTimeout(function (idLbl) {
            if(idLbl) {
                let title = document.getElementById(idLbl).innerHTML;
                let d1 = document.getElementsByClassName('ionic-selectable-modal');
                if(d1.length > 0) {
                  let d2 = d1[0].children[0].children[0].children[3].children[0].children[0];
                  d2.innerHTML = title;
                }
            }
        }, 100, idLabel);
    }
}



// WEBPACK FOOTER //
// ./src/directives/def-title-select/def-title-select-search.ts